import { OpEnum } from 'src/app/shared/enums/op.enum';
import { ParametersService } from '../services/parameters/parameters.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/parameters/parameters.service";
var FormatNumberService = /** @class */ (function () {
    function FormatNumberService(parametersService) {
        this.parametersService = parametersService;
    }
    FormatNumberService.prototype.formatNumberPhone = function (phone) {
        var cleaned = phone.replace(/\D/g, '').substring(0, 10);
        var regex = /^(\d{0,3})(\d{0,3})(\d{0,4})$/;
        var index1 = '$1';
        var parents = cleaned.length > 3 ? "(" + index1 + ")" : index1;
        var value = cleaned.replace(new RegExp(regex, 'g'), parents + " $2 $3");
        return { format: value.trim(), clearValue: cleaned };
    };
    FormatNumberService.prototype.currency = function (value, chunkLength, chunkDelimiter) {
        if (chunkLength === void 0) { chunkLength = 3; }
        if (chunkDelimiter === void 0) { chunkDelimiter = '.'; }
        var newValue = value.toString().replace(/\D/g, '').replace(/^0+/, '').substring(0, 11);
        var regex = "\\d(?=(\\d{" + chunkLength + "})+$)";
        var result = newValue.replace(new RegExp(regex, 'g'), "$&" + chunkDelimiter);
        return { format: "$" + result.trim(), clearValue: newValue };
    };
    FormatNumberService.prototype.numberPhoneValidator = function () {
        var prefijos = this.parametersService.getSetting(OpEnum.MOBILE_PHONE_PREFIXES);
        return function (control) {
            var value = control.value;
            if (value !== undefined && value.length >= 3) {
                var prefix = value.substring(0, 3);
                var result = prefijos.includes(prefix);
                return !result ? { notPrefix: true } : null;
            }
            return null;
        };
    };
    FormatNumberService.prototype.amountFormat = function (value) {
        return value.replace('$', '').split(/\./).join('').trim();
    };
    FormatNumberService.prototype.pcoFormat = function (value) {
        return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    };
    /**
     * Función que permite contar cantidad de decimales de un número
     * @param {number} val - Número con decimales
     * @returns - Cantidad de decimales
     */
    FormatNumberService.prototype.countDecimalDigits = function (val) {
        var char_array = val.toString().split(''); // split every single char
        var not_decimal = char_array.lastIndexOf('.');
        return (not_decimal < 0) ? 0 : char_array.length - (not_decimal !== 0 ? not_decimal + 1 : not_decimal);
    };
    FormatNumberService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormatNumberService_Factory() { return new FormatNumberService(i0.ɵɵinject(i1.ParametersService)); }, token: FormatNumberService, providedIn: "root" });
    return FormatNumberService;
}());
export { FormatNumberService };
